import React from 'react'
import { TYPES } from '../FormInput.v2/utils'
import TextInput, { type TextInputProps } from './TextInput'

export type EmailInputProps = Omit<TextInputProps, 'type' | 'staticText'>

function EmailInput (props: EmailInputProps) {
  return <TextInput {...props} type={TYPES.EMAIL} />
}

export default EmailInput
